import React from "react";
import { EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../core/security/SprintAccessRight";
import { EditLibraryAside } from "./EditLibraryAside";

export interface EditLibraryButtonAsideProps {
    fileRecordId: string;
    isDisabled: boolean;
    isLabeled?: boolean;
}

export const EditLibraryButtonAside: React.FunctionComponent<EditLibraryButtonAsideProps> = (
    props: EditLibraryButtonAsideProps
) => {
    const { fileRecordId, isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-library"
                disabled={isDisabled}
            />
            <EditLibraryAside fileRecordId={fileRecordId} isOpen={isOpen} onCancel={onClose} onSubmit={onClose} />
        </AuthorizationWrapper>
    );
};
